import { render, staticRenderFns } from "./vs-form-datatable.vue?vue&type=template&id=516fba04&scoped=true"
import script from "./vs-form-datatable.vue?vue&type=script&lang=js"
export * from "./vs-form-datatable.vue?vue&type=script&lang=js"
import style0 from "./vs-form-datatable.vue?vue&type=style&index=0&id=516fba04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516fba04",
  null
  
)

export default component.exports